import type { ApiEnvId } from './api';

// 注意单复数:列表页是 /links、/audits,详情页路由却是 /link/$id、/audit/$id
// (见 routes/link.$id.tsx、routes/audit.$id.tsx)。只列复数项会漏掉详情页,
// 因为 isAdminPathVisible 的前缀匹配是 `${visible}/`,`/links/` 匹配不到 `/link/`。
export const BETA_MANAGED_PATHS = [
  '/',
  '/links',
  '/billing',
  '/link',
  '/domains',
  '/audits',
  '/audit',
  '/rules',
  '/blocklist',
] as const;

export const PROD_MANAGED_PATHS = ['/rules'] as const;

export function visibleAdminPaths(env: ApiEnvId): readonly string[] {
  return env === 'beta' ? BETA_MANAGED_PATHS : PROD_MANAGED_PATHS;
}

export function isAdminPathVisible(env: ApiEnvId, path: string): boolean {
  return visibleAdminPaths(env).some(
    (visible) => path === visible || (visible !== '/' && path.startsWith(`${visible}/`)),
  );
}
